import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Layout from "../../../layout/default";
import Block from "../../../components/Block/Block";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import axios from "axios";
import { Icon } from "../../../components";
import api from "../../../services/auth/api";

// const baseURL = "http://127.0.0.1:8000/";

function Product() {
  const [data, setData] = useState({
    title: "",
    description: "",
    image_url: null,
    price: 0,
    category_id: "0",
  });

  const [validated, setValidated] = useState(false);
  const [CategoryListData, setCategoryListData] = useState([]);
  const navigate = useNavigate();

  // Handle input changes
  const handleInputs = (e) => {
    const { name, value, files } = e.target;
    if (name === "image_url" && files.length > 0) {
      setData({ ...data, [name]: files[0] }); // Save file object in state
    } else {
      setData({ ...data, [name]: value });
    }
  };

  // Fetch category list
  const getList = () => {
    api
      .get(`${process.env.REACT_APP_HOST}api/category`)
      .then((response) => {
        setCategoryListData(response.data.data || []);
      })
      .catch(() => {
        setCategoryListData([]);
      });
  };

  useEffect(() => {
    getList();
  }, []);

  // Submit form data
  const postData = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    api
      .post(`${process.env.REACT_APP_HOST}api/products`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.data.success) {
          saveSuccess();
          setData({
            title: "",
            description: "",
            image_url: null,
            price: 0,
            category_id: "0",
          });
          setValidated(false);
        }
      })
      .catch((err) => {
        saveError(err.response?.data?.validationErrors || "An error occurred.");
      });
  };

  const clear = () => {
    setData({
      title: "",
      description: "",
      image_url: null,
      price: 0,
      category_id: "0",
    });
    setValidated(false);
  };

  const saveSuccess = () => {
    Swal.fire({
      icon: "success",
      title: "Saved successfully",
    }).then(() => navigate("/shop/admin/product-list"));
  };

  const saveError = (message) => {
    Swal.fire({
      icon: "error",
      title: "Save attempt was not successful",
      html: typeof message === "object" ? Object.values(message).join("<br>") : message,
    });
  };

  return (
    <Layout title="Product">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Product</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Link
                  to="/shop/admin/product-list"
                  className="btn btn-primary btn-md d-md-none"
                >
                  <Icon name="arrow-long-left" />
                  <span>Go to List</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/shop/admin/product-list"
                  className="btn btn-primary d-none d-md-inline-flex"
                >
                  <Icon name="arrow-long-left" />
                  <span>Go to List</span>
                </Link>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block className="mt-n5">
        <Form noValidate validated={validated} onSubmit={postData}>
          <Row className="g-3">
            <Card>
              <Card.Body>
                <Row className="g-gs">
                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label>
                        Product Title<span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          name="title"
                          value={data.title}
                          onChange={handleInputs}
                          type="text"
                          placeholder="Enter Product Title"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Product Title is required.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label>
                        Product Description<span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          name="description"
                          value={data.description}
                          onChange={handleInputs}
                          type="text"
                          placeholder="Enter Product Description"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Product Description is required.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label>
                        Product Image<span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          name="image_url"
                          onChange={handleInputs}
                          type="file"
                          accept="image/*"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Please upload a valid product image.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label>
                        Category ID<span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Select
                          name="category_id"
                          value={data.category_id}
                          onChange={handleInputs}
                          required
                        >
                          <option value="0">Select Category</option>
                          {CategoryListData.map((category) => (
                            <option key={category.id} value={category.id}>
                              {category.title}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          Please select a category.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <div className="gap-col">
              <ul className="d-flex align-items-center justify-content-center gap g-3">
                <li>
                  <Button type="submit" variant="primary">
                    Save
                  </Button>
                </li>
                <li>
                  <Button type="button" variant="secondary" onClick={clear}>
                    Cancel
                  </Button>
                </li>
              </ul>
            </div>
          </Row>
        </Form>
      </Block>
    </Layout>
  );
}

export default Product;
